<div
  class="product-card-horizontal flex h-full w-full cursor-pointer gap-3 overflow-hidden"
  [style.backgroundColor]="_cardColor() || '#ffffff'"
  (click)="!isProductAvailable() ? null : addToCart()"
>
  <!-- Product Image Section -->
  <div class="imageContainer relative h-[176px] w-[176px] flex-shrink-0 overflow-hidden">
    @if (quantity()) {
      <div
        class="absolute left-2 top-2 z-40 flex h-6 w-6 items-center justify-center rounded-full bg-neutral-300 text-center text-sm font-bold"
      >
        {{ quantity() }}
      </div>
    }
    <div
      class="absolute inset-0 h-[176px] w-[176px]"
      [appRadialGradient]="product()[ProductKeys.Images]?.thumbnail?.colors"
    ></div>
    @if (product()[ProductKeys.Images]?.thumbnail) {
      <div class="relative z-10">
        <img
          [src]="
            product()[ProductKeys.Images]?.thumbnail?.url ||
            product()[ProductKeys.Images]?.cover?.url ||
            '/assets/img/placeholder-product.png'
          "
          [alt]="product()[ProductKeys.Name]"
          class="h-[176px] w-[176px] object-cover"
          loading="lazy"
        />
        @let visibleLabels = product().labels | appVisibleLabels;
        @if (visibleLabels?.length) {
          <ul class="top-0 right-0 z-50 flex flex-wrap justify-center gap-1 absolute">
            @for (label of visibleLabels; track label) {
              <li class="bg-highlight-100 text-highlight-800 p-1 rounded-l-sm text-sm text-right">
                {{ label.name }}
              </li>
            }
          </ul>
        }
      </div>
    }

    <!-- Discount Badge -->
    @if (displayDiscount()) {
      <div
        class="absolute left-3 top-3 rounded-full bg-green-500 px-3 py-1 text-sm font-bold text-white shadow-lg"
      >
        {{ discountPercentage() }}%
      </div>
    }

    <!-- Unavailable Overlay -->
    @if (!isProductAvailable()) {
      <div class="absolute inset-0 z-30 flex items-center justify-center bg-black bg-opacity-50">
        <span class="text-lg font-bold text-white">{{ '_.UNAVAILABLE' | translate }}</span>
      </div>
    }
  </div>

  <!-- Product Content Section -->
  <div class="flex min-w-0 flex-1 flex-col justify-between">
    <!-- Product Info -->
    <div class="flex flex-1 flex-col">
      <!-- Product Name -->
      <h3
        class="mb-1 line-clamp-2 text-xl font-bold leading-tight"
        [style.color]="(textColor() | contentBuilderColor) || '#333333'"
      >
        {{ product()[ProductKeys.Name] }}
      </h3>

      <!-- Product Description (if available) -->
      @if (product()[ProductKeys.Description]) {
        <p
          class="line-clamp-4 text-left text-sm opacity-75"
          [style.color]="(textColor() | contentBuilderColor) || '#666666'"
        >
          {{ product()[ProductKeys.Description] | firstLine }}
        </p>
      }
    </div>

    <!-- Price and Action Section -->
    <div class="mt-auto flex items-center justify-between">
      <!-- Price -->
      <div class="flex-1">
        <app-price-atom
          [amount]="
            +(
              product()[ProductKeys.PriceToDisplay] ||
              product()[ProductKeys.Discount] ||
              product()[ProductKeys.Price] ||
              0
            )
          "
          [bold]="true"
          [discount]="_hasDiscountPromotionLabel()"
          size="SM"
          class="text-sm font-bold"
          [priceColor]="priceColor()"
        ></app-price-atom>
      </div>

      <div class="flex items-center">
        @if (
          isShowProductIcon() && (product().description?.length || product().allergens?.length)
        ) {
          <i
            (click)="!isProductAvailable() ? null : showProductModal(); $event.stopPropagation()"
            class="icon icon-c-info-3 pointer-events-auto mr-[3px] flex items-center justify-center text-lg font-semibold"
            [style.color]="textColor() | contentBuilderColor"
            [class.opacity-50]="!isProductAvailable()"
          ></i>
        }
      </div>
    </div>
  </div>
</div>
